import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { classNames } from "../../helpers/classNames";
import Button from "../../components/form/Button";

const UpdatedModal = ({
  title,
  subtitle,
  children,
  open = false,
  onClose = () => {},
  size = "xl4",
  modalDialogueStyle = "pb-4",
  divStyle,
  divheaderStyle,
  overflow = "",
  isOutsideCloseEnable = true,
  isCrossButton = true,
  header = true,
}) => {
  const modalSize = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    xl2: "sm:max-w-2xl",
    xl3: "sm:max-w-3xl",
    xl4: "sm:max-w-4xl",
    xl5: "sm:max-w-5xl",
    xl6: "sm:max-w-6xl",
    xl7: "sm:max-w-7xl",
    xl8: "sm:max-w-8xl",
    xl9: "sm:max-w-9xl",
    full: "max-w-full",
  };

  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-60"
          onClose={() => (isOutsideCloseEnable ? onClose(false) : "")}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-800"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gradient-to-b from-opplio-darkGray/80 via-opplio-darkGray/40 to-opplio-darkGray/80 backdrop-filter backdrop-blur-sm bg-black/60" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center ">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={classNames(
                    `w-full ${modalSize[size]} transform text-left align-middle shadow-xl transition-all rounded-xl`,
                    overflow
                  )}
                >
                  <div
                    className={classNames(
                      "rounded-2xl bg-white",
                      modalDialogueStyle
                    )}
                  >
                    {header && (
                      <div
                        className={classNames(
                          "relative py-2 px-4 flex justify-between rounded-t-xl bg-blue-600",
                          divheaderStyle
                        )}
                      >
                        <div className="mx-auto flex-shrink">
                          <h2 className="text-xl tracking-tight font-semibold text-opplio-darkGray text-white">
                            {title}
                          </h2>
                          <div className="text-sm font-medium text-opplio-grayW">
                            {subtitle}
                          </div>
                        </div>
                        {isCrossButton && (
                          <div className="absolute right-3 top-3 flex-shrink-0 rounded-md z-10">
                            <Button
                              buttonIcon={"fa-regular fa-xmark"}
                              buttonIconPosition={"left"}
                              buttonClasses="!w-8 !h-8 !p-0 !justify-center !rounded-full !text-lg !bg-white hover:rotate-90 !text-slate-500 border-slate-100"
                              buttonFunction={onClose}
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {!header && isCrossButton && (
                      <div className="absolute -top-3 -right-3 z-10">
                        <Button
                          buttonIcon={"fa-regular fa-xmark"}
                          buttonIconPosition={"left"}
                          buttonClasses={
                            "!w-8 !h-8 !p-0 !justify-center !rounded-full !text-lg !bg-white hover:rotate-90 !text-slate-500 border border-slate-100"
                          }
                          buttonFunction={onClose}
                        />
                      </div>
                    )}
                    <div className={classNames("relative px-4", divStyle)}>
                      {children}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default UpdatedModal;
